import { HomeActionTypes } from './home.types';

const homeContentGetRequest = () => ({ type: HomeActionTypes.HOME_GET_REQUEST });
const homeContentGetSuccess = () => ({ type: HomeActionTypes.HOME_GET_SUCCESS });
const homeContentGetFailure = () => ({ type: HomeActionTypes.HOME_GET_FAILURE });
const homeContentSet = payload => ({ type: HomeActionTypes.HOME_SET, payload });
const homeContentLoading = payload => ({ type: HomeActionTypes.HOME_LOADING, payload });
const homeContentResetState = () => ({ type: HomeActionTypes.HOME_RESET_STATE });

const sawHome = () => ({ type: HomeActionTypes.SAW_HOME });
const menuIsOpen = payload => ({ type: HomeActionTypes.MENU_IS_OPEN, payload });

const setHomeAiWrapperRef = ({ aiWrapperRef }) => ({
  type: HomeActionTypes.SET_AI_WRAPPER_REF,
  payload: { aiWrapperRef },
});

const userProductsPriceRequest = payload => ({ type: HomeActionTypes.USER_PRODUCTS_PRICE_REQUEST, payload });
const userProductsPriceSuccess = payload => ({ type: HomeActionTypes.USER_PRODUCTS_PRICE_SUCCESS, payload });
const userProductsPriceFailure = () => ({ type: HomeActionTypes.USER_PRODUCTS_PRICE_FAILURE });

const actions = {
  getHomeContent: {
    request: homeContentGetRequest,
    success: homeContentGetSuccess,
    failure: homeContentGetFailure,
    set: homeContentSet,
    reset: homeContentResetState,
  },
  loading: homeContentLoading,
  sawHome,
  setHomeAiWrapperRef,
  menuIsOpen,
  userProductsPrice: {
    request: userProductsPriceRequest,
    success: userProductsPriceSuccess,
    failure: userProductsPriceFailure,
  },
};

export default actions;
